import * as yup from 'yup'
import { TYPE_REQUIRED } from 'constants/errors'

export const schemaString = yup.string().typeError(TYPE_REQUIRED).required(TYPE_REQUIRED)
export const schemaNumber = yup.number().typeError(TYPE_REQUIRED).required(TYPE_REQUIRED)
export const schemaNumberInString = yup.string().typeError(TYPE_REQUIRED).required(TYPE_REQUIRED).transform((value: string) => parseFloat(value).toFixed(2))
export const schemaArrayOfStrings = yup.array().of(yup.string())
